/**
 * Swap the Wysh heart for the Fluevog brand heart on the PDP Add to Wishlist
 * button ([data-wysh-product-button-placeholder]). Product cards render the
 * theme's own heart instead — see snippets/fluevog-card-wishlist.liquid.
 *
 * One heart icon: outline by default; interior fill appears when button has .added.
 */
(function () {
  const PLACEHOLDER = '[data-wysh-product-button-placeholder]';
  const SAVED_LABEL = 'Remove from wishlist';

  const cloneBrandIcon = (brandSvg) => {
    const icon = brandSvg.cloneNode(true);
    icon.setAttribute('aria-hidden', 'true');
    // One glyph for both states — Wysh toggles .added on the button; CSS fills it.
    icon.classList.add('not-added', 'added', 'icon');
    icon.querySelectorAll('[fill]').forEach((el) => {
      const fill = el.getAttribute('fill');
      if (fill && fill !== 'none') el.setAttribute('fill', 'currentColor');
    });
    return icon;
  };

  const applyBrandIcon = (root) => {
    const button = root.querySelector('.wysh-product-button, .wysh-app-button');
    if (!button || button.dataset.fvWyshIcon === 'true') return;

    const brandSvg = root
      .querySelector('.fv-wishlist__icon-template')
      ?.content?.querySelector('svg');
    if (!brandSvg) return;

    button.querySelectorAll(':scope > svg').forEach((svg) => {
      if (!svg.classList.contains('wysh-loading') && !svg.classList.contains('wysh-toggle-dropdown-icon')) {
        svg.remove();
      }
    });
    button.prepend(cloneBrandIcon(brandSvg));
    button.dataset.fvWyshIcon = 'true';

    const label = button.querySelector('.wysh-text');
    if (label && label.dataset.fvRemoveReady !== 'true') {
      if (!label.dataset.addText) {
        label.dataset.addText = label.textContent || 'Add to Wishlist';
      }
      label.dataset.removeText = SAVED_LABEL;
      if (button.classList.contains('added')) {
        label.textContent = SAVED_LABEL;
      }
      label.dataset.fvRemoveReady = 'true';
    }
  };

  const apply = () => {
    document.querySelectorAll(PLACEHOLDER).forEach(applyBrandIcon);
  };

  apply();
  const observer = new MutationObserver(apply);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
